import styled from 'styled-components';
import { Modal, Divider } from 'antd';
import { Paragraph, Title, Text } from '@/components/Typography';

export const ModalStyled = styled(Modal)`
	.ant-modal-content {
		padding: 30px 0;
		min-width: 100%;
		max-width: 100%;
		border-radius: 15px;
	}
	.ant-modal-header {
		border-bottom: none;
	}
	.ant-modal-content {
		border: none;
	}
	@media (max-width: 1149px) {
		.ant-row .ant-col .ant-row .ant-typography,
		.ant-typography-paragraph,
		.ant-typography.ant-typography-paragraph,
		.ant-typography p,
		p,
		span.ant-typography {
			font-size: 12px !important;
		}
	}
`;

export const CustomTitle = styled(Title)`
	font-size: 25px;
	line-height: 32px;
	font-weight: 600;
	letter-spacing: -0.5%;
`;

export const CustomParagraph = styled(Paragraph)`
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	letter-spacing: 0%;
`;

export const CustomTableText = styled(Text)`
	font-size: 14px;
	line-height: 16px;
	font-weight: 400;
	letter-spacing: -0.5%;
`;

export const VerticalDivider = styled(Divider)`
	width: 0px;
	height: 20px;
	border: 1px solid #f0f0f0;
	margin: 0rem 0.5rem;
`;

export const ListItem = styled.div`
	display: flex;
	height: 48px;
	padding: 0 16px;
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	align-items: center;
	margin-bottom: 16px;
	border: 1px solid ${({ theme }) => theme.palette.secondary['200']};
	background-color: ${({ theme }) => theme.palette.secondary.white};

	@media (max-width: 1149px) {
		.ant-typography {
			font-size: 12px !important;
		}
	}
`;

export const Block = styled.div`
	width: 100%;
`;
